import { render, staticRenderFns } from "./dataAPIMarket.vue?vue&type=template&id=ac41428c&scoped=true"
import script from "./dataAPIMarket.vue?vue&type=script&lang=js"
export * from "./dataAPIMarket.vue?vue&type=script&lang=js"
import style0 from "./dataAPIMarket.vue?vue&type=style&index=0&id=ac41428c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac41428c",
  null
  
)

export default component.exports